<template>
  <w-form-table>
    <thead>
      <tr>
        <th>Lp.</th>

        <th>Tytuł/Nazwa dokumentu</th>

        <th>Karta nr</th>

        <th />
      </tr>
    </thead>

    <tbody>
      <tr v-for="(item, index) in schema.listOfCases.$items" :key="'list_' + index">
        <td class="text-center">{{ index + 1 }}</td>
        
        <w-table-cell :model="item.$item.name">
          <w-input :model="item.$item.name" />
        </w-table-cell>

        <w-table-cell :model="item.$item.cardNr">
          <w-input :model="item.$item.cardNr" />
        </w-table-cell>

        <w-row-buttons
          class="middle flex-nowrap"
          :model="item.$item"
          :move-up="index != 0"
          :move-down="item.$item.$parent.$value.length - 1 !== index"
        />
      </tr>

      <tr>
        <td colspan="4">
          <w-add-row :model="schema.listOfCases">Dodaj dokument</w-add-row>
        </td>
      </tr>
    </tbody>
  </w-form-table>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

export default {
  components,
  props: {
    schema: { type: Object, require: false }
  }
};
</script>
